var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section_base"},[_c('section-header',{attrs:{"title":_vm.title,"description":_vm.description},scopedSlots:_vm._u([{key:"right",fn:function(){return [_vm._t("right")]},proxy:true}],null,true)}),_vm._v(" "),_c('div',{staticClass:"section_base--inner"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }